import { render, staticRenderFns } from "./TiktokLogs.vue?vue&type=template&id=5847d064&"
import script from "./TiktokLogs.vue?vue&type=script&lang=js&"
export * from "./TiktokLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports